<div class="box cursor-pointer" [routerLink]="targetRoute" (click)="disabled?null:onClick()">
    <span class="material-icons-outlined" style="font-size: 120px; padding-top: 50px; color: #0CAFFF;">
        {{ iconName }}
        </span>
    <div style="overflow-wrap: break-word;">{{ label  | translate }}</div>
</div>